import type { Router } from "vue-router";

/** Fire a custom event. No-op during SSG or if PostHog isn't loaded. */
export function capture(event: string, properties?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  import("posthog-js").then(({ default: posthog }) => {
    posthog.capture(event, properties);
  });
}

export function initPostHog(router: Router): void {
  if (typeof window === "undefined") return;

  const apiKey = import.meta.env.VITE_POSTHOG_KEY;
  if (!apiKey) return;

  const boot = () => {
    import("posthog-js").then(({ default: posthog }) => {
      posthog.init(apiKey, {
        api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
        persistence: "memory",
        person_profiles: "always",
        capture_pageview: false,
        capture_pageleave: true,
        autocapture: false,
        disable_session_recording: true,
        loaded: (ph) => {
          if (import.meta.env.DEV) {
            ph.opt_out_capturing();
          }
        },
      });

      router.afterEach((to) => {
        posthog.capture("$pageview", {
          $current_url: window.location.origin + to.fullPath,
        });
      });
    });
  };

  // Defer analytics until browser is idle to avoid blocking FCP/LCP
  if ("requestIdleCallback" in window) {
    requestIdleCallback(boot, { timeout: 3000 });
  } else {
    setTimeout(boot, 2000);
  }
}
